<template>
<div>
<!-- Menu moderno com gradiente e sombra -->
<nav class="bg-gradient-to-r from-green-800 to-green-700 shadow-lg sticky top-0 z-50">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="relative flex items-center justify-between h-20">
      
      <!-- Mobile menu button -->
      <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
        <button 
          v-on:click="toggleMenu('navbar')" 
          class="inline-flex items-center justify-center p-2.5 rounded-lg text-white hover:bg-green-900 focus:outline-none focus:ring-2 focus:ring-white transition-all duration-200"
          aria-expanded="false">
          <span class="sr-only">Abrir menu</span>
          <svg v-if="!showMenu" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg v-else class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Logo e links desktop -->
      <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
        <!-- Logo -->
        <div class="flex-shrink-0 flex items-center">
          <img class="h-14 w-auto sm:h-16 drop-shadow-lg" src="@/assets/images/logo-pdb.png" alt="Papo de Boleiro">
        </div>

        <!-- Links Desktop -->
        <div class="hidden sm:flex sm:ml-8 sm:items-center sm:space-x-2">
          <!-- Home -->
          <router-link 
            to="/" 
            class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200 border-b-2 border-transparent hover:border-green-300">
            <i class="fas fa-home"></i>
            <span>Home</span>
          </router-link>

          <!-- Bolão Dropdown -->
          <div class="relative">
            <button 
              v-on:click="toggleMenu('betting')"
              class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200">
              <i class="fas fa-trophy"></i>
              <span>Bolão Brasileiro</span>
              <svg class="h-4 w-4 transition-transform duration-200" :class="{'rotate-180': showBetting}" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>

            <!-- Dropdown moderno -->
            <transition
              enter-active-class="transition ease-out duration-200"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-150"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95">
              <div 
                v-show="showBetting"
                class="absolute left-0 mt-2 w-64 rounded-xl shadow-2xl bg-white ring-1 ring-black ring-opacity-5 overflow-hidden z-50">
                <div class="py-2">
                  <router-link 
                    to="/ranking" 
                    class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150"
                    @click="showBetting = false">
                    <i class="fas fa-chart-bar w-5 text-green-600"></i>
                    <span class="font-medium">Ranking</span>
                  </router-link>

                  <router-link 
                    to="/standings"
                    v-bind:class="{'hidden': !hasPermission('UserBolao')}"
                    class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150"
                    @click="showBetting = false">
                    <i class="fas fa-table w-5 text-green-600"></i>
                    <span class="font-medium">Classificação Brasileirão</span>
                  </router-link>

                  <router-link 
                    to="/current-round"
                    class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150"
                    @click="showBetting = false">
                    <i class="fas fa-calendar-check w-5 text-green-600"></i>
                    <span class="font-medium">Rodada Atual</span>
                  </router-link>

                  <router-link 
                    v-bind:class="{'hidden': !hasPermission('UserBolao')}"
                    :to="{ name: 'NewBetting', params: {userId: this.getUserId()}}"
                    class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150"
                    @click="showBetting = false">
                    <i class="fas fa-edit w-5 text-green-600"></i>
                    <span class="font-medium">Criar Palpite</span>
                  </router-link>

                  <router-link 
                    to="/bet-rules"
                    class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150"
                    @click="showBetting = false">
                    <i class="fas fa-book w-5 text-green-600"></i>
                    <span class="font-medium">Regras</span>
                  </router-link>

                  <router-link 
                    to="/betting-saved"
                    v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
                    class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150"
                    @click="showBetting = false">
                    <i class="fas fa-save w-5 text-green-600"></i>
                    <span class="font-medium">Palpites Criados</span>
                  </router-link>

                  <router-link 
                    to="/reports-betting"
                    class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150"
                    @click="showBetting = false">
                    <i class="fas fa-chart-line w-5 text-green-600"></i>
                    <span class="font-medium">Ranking Report</span>
                  </router-link>

                  <div 
                    v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
                    class="border-t border-gray-100 mt-2 pt-2">
                    <a 
                      href="#" 
                      @click.prevent="updateRanking(); showBetting = false"
                      class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                      <i class="fas fa-sync-alt w-5 text-green-600"></i>
                      <span class="font-medium">Atualizar Ranking</span>
                    </a>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- Futebol -->
          <a 
            href="#" 
            class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200">
            <i class="fas fa-futbol"></i>
            <span>Futebol</span>
          </a>

          <!-- Cartola -->
          <a 
            href="#" 
            class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200">
            <i class="fas fa-users"></i>
            <span>Cartola</span>
          </a>
        </div>
      </div>

      <!-- Notificações e Profile (direita) -->
      <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 gap-2">
        <!-- Notificações -->
        <button class="relative p-2 rounded-lg text-white hover:bg-white hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-white transition-all duration-200">
          <span class="sr-only">Ver notificações</span>
          <i class="fas fa-bell text-lg"></i>
          <!-- Badge de notificação -->
          <span class="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-green-800"></span>
        </button>

        <!-- Profile dropdown -->
        <div class="ml-1 relative">
          <button 
            v-on:click="toggleMenu('profile')"
            class="flex items-center gap-2 p-1 rounded-lg hover:bg-white hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-white transition-all duration-200">
            <img class="h-10 w-10 rounded-lg ring-2 ring-white ring-opacity-50 object-cover" :src="userProfile.picture" alt="Profile">
          </button>

          <!-- Profile Dropdown -->
          <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95">
            <div 
              v-show="showProfile"
              class="origin-top-right absolute right-0 mt-2 w-56 rounded-xl shadow-2xl bg-white ring-1 ring-black ring-opacity-5 overflow-hidden z-50">
              <div class="px-4 py-3 border-b border-gray-100">
                <p class="text-sm font-medium text-gray-900">{{ userProfile.name || 'Usuário' }}</p>
                <p class="text-xs text-gray-500 truncate">{{ userProfile.email || '' }}</p>
              </div>
              <div class="py-2">
                <a 
                  href="#" 
                  class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150">
                  <i class="fas fa-user w-5 text-gray-400"></i>
                  <span>Meu Perfil</span>
                </a>
                <router-link 
                  v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
                  to="/users"
                  class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                  @click="showProfile = false">
                  <i class="fas fa-users-cog w-5 text-gray-400"></i>
                  <span>Gerenciar Usuários</span>
                </router-link>
              </div>
              <div class="border-t border-gray-100">
                <a 
                  @click.prevent="logoff"
                  class="flex items-center gap-3 px-4 py-3 text-sm text-red-600 hover:bg-red-50 cursor-pointer transition-colors duration-150">
                  <i class="fas fa-sign-out-alt w-5"></i>
                  <span class="font-medium">Sair</span>
                </a>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>

  <!-- Menu Mobile Moderno -->
  <transition
    enter-active-class="transition ease-out duration-200"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition ease-in duration-150"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0">
    <div v-show="showMenu" class="sm:hidden">
      <!-- Overlay escuro -->
      <div class="fixed inset-0 bg-black bg-opacity-50 z-40" @click="showMenu = false"></div>
      
      <!-- Sidebar -->
      <div class="fixed inset-y-0 left-0 w-80 bg-white shadow-2xl z-50 overflow-y-auto">
        <!-- Header do menu mobile -->
        <div class="bg-gradient-to-r from-green-800 to-green-700 p-6">
          <div class="flex items-center gap-4">
            <img class="h-12 w-12 rounded-lg ring-2 ring-white object-cover" :src="userProfile.picture" alt="Profile">
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-white truncate">{{ userProfile.name || 'Usuário' }}</p>
              <p class="text-xs text-green-100 truncate">{{ userProfile.email || '' }}</p>
            </div>
          </div>
        </div>

        <!-- Links do menu -->
        <div class="py-4 px-3 space-y-1">
          <!-- Home -->
          <router-link 
            to="/"
            @click="showMenu = false"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
            <i class="fas fa-home w-5 text-green-600"></i>
            <span class="font-medium">Home</span>
          </router-link>

          <!-- Bolão Brasileiro -->
          <div>
            <button 
              v-on:click="toggleMenu('betting-mobile')"
              class="w-full flex items-center justify-between px-4 py-3 rounded-lg text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
              <div class="flex items-center gap-3">
                <i class="fas fa-trophy w-5 text-green-600"></i>
                <span class="font-medium">Bolão Brasileiro</span>
              </div>
              <svg 
                class="h-5 w-5 transition-transform duration-200" 
                :class="{'rotate-180': showBettingMobile}"
                fill="currentColor" 
                viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>

            <!-- Submenu Bolão -->
            <transition
              enter-active-class="transition ease-out duration-200"
              enter-from-class="transform opacity-0 -translate-y-2"
              enter-to-class="transform opacity-100 translate-y-0"
              leave-active-class="transition ease-in duration-150"
              leave-from-class="transform opacity-100 translate-y-0"
              leave-to-class="transform opacity-0 -translate-y-2">
              <div v-show="showBettingMobile" class="ml-8 mt-1 space-y-1 border-l-2 border-green-200 pl-4">
                <router-link 
                  to="/ranking"
                  @click="showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-chart-bar text-xs text-green-500"></i>
                  <span>Ranking</span>
                </router-link>

                <router-link 
                  to="/standings"
                  v-bind:class="{'hidden': !hasPermission('UserBolao')}"
                  @click="showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-table text-xs text-green-500"></i>
                  <span>Classificação Brasileirão</span>
                </router-link>

                <router-link 
                  to="/current-round"
                  @click="showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-calendar-check text-xs text-green-500"></i>
                  <span>Rodada Atual</span>
                </router-link>

                <router-link 
                  :to="{ name: 'NewBetting', params: {userId: this.getUserId()}}"
                  v-bind:class="{'hidden': !hasPermission('UserBolao')}"
                  @click="showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-edit text-xs text-green-500"></i>
                  <span>Criar Palpite</span>
                </router-link>

                <router-link 
                  to="/bet-rules"
                  @click="showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-book text-xs text-green-500"></i>
                  <span>Regras</span>
                </router-link>

                <router-link 
                  to="/betting-saved"
                  v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
                  @click="showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-save text-xs text-green-500"></i>
                  <span>Palpites Criados</span>
                </router-link>

                <router-link 
                  to="/reports-betting"
                  @click="showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-chart-line text-xs text-green-500"></i>
                  <span>Ranking Report</span>
                </router-link>

                <a 
                  href="#"
                  v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
                  @click.prevent="updateRanking(); showMenu = false"
                  class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
                  <i class="fas fa-sync-alt text-xs text-green-500"></i>
                  <span>Atualizar Ranking</span>
                </a>
              </div>
            </transition>
          </div>

          <!-- Futebol -->
          <a 
            href="#"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
            <i class="fas fa-futbol w-5 text-green-600"></i>
            <span class="font-medium">Futebol</span>
          </a>

          <!-- Cartola -->
          <a 
            href="#"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150">
            <i class="fas fa-users w-5 text-green-600"></i>
            <span class="font-medium">Cartola</span>
          </a>

          <!-- Divisor -->
          <div class="border-t border-gray-200 my-4"></div>

          <!-- Gerenciar Usuários -->
          <router-link 
            to="/users"
            v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
            @click="showMenu = false"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors duration-150">
            <i class="fas fa-users-cog w-5 text-gray-400"></i>
            <span class="font-medium">Gerenciar Usuários</span>
          </router-link>

          <!-- Sair -->
          <a 
            @click.prevent="logoff"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 cursor-pointer transition-colors duration-150">
            <i class="fas fa-sign-out-alt w-5"></i>
            <span class="font-medium">Sair</span>
          </a>
        </div>
      </div>
    </div>
  </transition>
</nav>

<!-- Alert de aprovação pendente modernizado -->
<transition
  enter-active-class="transition ease-out duration-300"
  enter-from-class="transform -translate-y-full opacity-0"
  enter-to-class="transform translate-y-0 opacity-100"
  leave-active-class="transition ease-in duration-200"
  leave-from-class="transform translate-y-0 opacity-100"
  leave-to-class="transform -translate-y-full opacity-0">
  <div v-if="isGuest()" class="mx-4 mt-4 mb-2 sm:mx-6">
    <div class="rounded-xl bg-gradient-to-r from-red-500 to-red-600 shadow-lg">
      <div class="flex items-center gap-4 px-6 py-4">
        <div class="flex-shrink-0">
          <div class="flex items-center justify-center h-10 w-10 rounded-lg bg-white bg-opacity-20">
            <i class="fas fa-exclamation-triangle text-white text-lg"></i>
          </div>
        </div>
        <div class="flex-1">
          <h3 class="text-sm font-semibold text-white">
            Aguardando Aprovação
          </h3>
          <p class="text-xs text-red-100 mt-0.5">
            Sua conta está pendente de aprovação pelos administradores
          </p>
        </div>
        <button class="flex-shrink-0 text-white hover:text-red-100 transition-colors duration-150">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</transition>
</div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import jwt_decode from 'jwt-decode';
import { useToast } from "vue-toastification";
import RankingService from '@/services/rankingService';

export default {
  name: 'NavigationMenu',
  setup() {
      const toast = useToast();
      return { toast }
  },
  computed: {
    ...mapGetters('user', {
      userProfile: 'userProfile',
    })
  },
  created() {
    let token = localStorage.getItem('token');
    if (token !== null) {
      try {
        let payload = jwt_decode(token);
        this.userData = payload;
      } catch (err) { console.log(err)}
    }
  },
  methods: {
    getUserId() {
      if (this.userData.length == 0) {
        return false;
      }
      return this.userData._id;
    },
    isGuest() {
      if (this.userData.length == 0) {
        return false;
      }
      let { rules } = this.userData;
      return rules.filter(data => data === "Guest").length > 0;
    },
    async auth() {
      await this.login();
      this.$router.push('/');
    },
    async logoff() {
      await this.logout();
      this.$router.push('/login');
    },
    toggleMenu(menu) {
        switch (menu) {
          case 'betting':
            this.showBetting = !this.showBetting
            return;
          case 'betting-mobile':
            this.showBettingMobile = !this.showBettingMobile
            return;
          case 'profile':
            this.showProfile = !this.showProfile;
            return;
          case 'navbar':
            this.showMenu = !this.showMenu;
            return;
          default:
            return;
        }
    },
    hasPermission(permission) {
      if (this.userData.length == 0) {
        return false;
      }
      let { rules } = this.userData;
      return rules.filter(data => data === permission).length > 0;
    },
    updateRanking() {
      RankingService.updateRanking().then(data => {
        console.log(data.status);
        this.toast.success("Atualizando o ranking.", {
          onClose: () => {
            location.reload()
          }
        });
      }).catch(error => {
        this.toast.error(`Erro ao atualizar: ${error.getMessage()}`);
      })
    },
    ...mapActions('user', {
      login: 'login',
      logout: 'logout'
    })
  },
  data() {
    return {
      showMenu: false,
      showProfile: false,
      showBetting: false,
      showBettingMobile: false,
      userData: '',
    }
  },
}
</script>